'use strict';

var vkBeautify = require('vkbeautify');
var SystemStatusFlightSentResponseDirective = function SystemStatusFlightSentResponseDirective() {
  return {
    restrict: 'E',
    template: require('../templates/system-status-flight-sent-response.html'),
    link: function link($scope) {
      $scope.$on('statusMessage:show', function () {
        $scope.responseParsedContent = vkBeautify.xml($scope.modalData.statusContent || '', 2);
        if ($scope.modalData.sentStatus) {
          $scope.responseStatus = 'RECEIVED';
        }
        if (!$scope.modalData.sentStatus) {
          $scope.responseStatus = 'SENT';
        }
      });
    }
  };
};
SystemStatusFlightSentResponseDirective.$inject = [];
module.exports = SystemStatusFlightSentResponseDirective;